import { render, staticRenderFns } from "./FacilityOverview.vue?vue&type=template&id=24452963&"
import script from "./FacilityOverview.vue?vue&type=script&lang=js&"
export * from "./FacilityOverview.vue?vue&type=script&lang=js&"
import style0 from "./FacilityOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports